import { render, staticRenderFns } from "./DsbBreadcrumbs.vue?vue&type=template&id=ace3ac22&functional=true"
import script from "./DsbBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./DsbBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./DsbBreadcrumbs.vue?vue&type=style&index=0&id=ace3ac22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports